import SoloResults from './SoloResults';
export default SoloResults;
